// src/pages/AddBatch.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import AddBatchForm from "../components/AddBatchForm";

const API_BASE_URL = "https://nzpdp-traceability-system-production-c63a.up.railway.app";

const AddBatch = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/admin/products`)
      .then((res) => setProducts(res.data))
      .catch((err) => console.error("Error fetching products:", err));
  }, []);

  const handleSubmit = (event, batchData) => {
    event.preventDefault();
    // batchData => { batch_no, product_code, manufacture_date }
 
    axios
      .post(`${API_BASE_URL}/api/admin/add_batch`, batchData)
      .then((response) => {
        alert(response.data.message);
      })
      .catch((error) => {
        alert(
          "Error adding batch: " + (error.response?.data?.error || error.message)
        );
      });
  };

  return (
    <div>
      <h3>Add New Batch</h3>
      <AddBatchForm
        products={products}
        onSubmit={handleSubmit}
      />
    </div>
  );
};

export default AddBatch;
